import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function AnimalDetails() {
  const [animalData, setAnimalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnimalData = async () => {
      try {
        const response = await axios.get(
          'https://apiiq.jamamasjidquba.com/api/animals/animaldetails',
          { withCredentials: true }
        );
        setAnimalData(response.data.data || []);
      } catch (error) {
        console.error('Error fetching animal data:', error);
        setAnimalData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAnimalData();
  }, []);

  const handleCardClick = (animal) => {
    navigate('/insertAnimalStatus', {
      state: {
        animal_cat: animal.animal_cat,
        animal_subcat: animal.animal_subcat,
        day: animal.day,
      },
    });
  };

  const getSubcatColorStyle = (subcat = '', cat = '') => {
    const normalizedSubcat = subcat.trim().toLowerCase();
    const normalizedCat = cat.trim().toLowerCase();

    if (normalizedSubcat === 'premium' && normalizedCat === 'cow') {
      return { backgroundColor: '#27548A', color: '#fff' };
    }
    if (normalizedSubcat === 'ijtimai' && normalizedCat === 'cow') {
      return { backgroundColor: '#16610E', color: '#fff' };
    }
    if (normalizedSubcat === 'assan' && normalizedCat === 'cow') {
      return { backgroundColor: '#EC7FA9', color: '#fff' };
    }
    if (normalizedSubcat === 'assan' && normalizedCat === 'goat') {
      return { backgroundColor: '#FFB200', color: '#fff' };
    }
    if (normalizedSubcat === 'ijtimai' && normalizedCat === 'goat') {
      return { backgroundColor: '#AA60C8', color: '#fff' };
    }

    return {}; // Default style
  };

  // ✅ Group animals by day
  const groupedByDay = animalData.reduce((acc, animal) => {
    const day = animal.day || 'Unknown';
    if (!acc[day]) acc[day] = [];
    acc[day].push(animal);
    return acc;
  }, {});

  if (loading) return <div className="text-center">Loading...</div>;

  return (
    <div className="p-4 container">
      <hr />
      <h1 className="mb-4 text-center ">Animal Status </h1>
      <hr />

      {Object.keys(groupedByDay).length > 0 ? (
        Object.entries(groupedByDay).map(([day, animals], index) => (
          <div key={index} className="mb-5 border rounded p-3 shadow-sm bg-light">
            <h2 className="text-center text-bolder mb-3">Day: {day}</h2>
            <hr className=''/>
            <div className="row">
              {animals.map((animal, idx) => (
                <div
                  key={idx}
                  className="col-md-3 mb-3 cursor-pointer"
                  onClick={() => handleCardClick(animal)}
                >
                  <div
                    className="card p-2 px-3 text-center border border-dark"
                    style={getSubcatColorStyle(animal.animal_subcat, animal.animal_cat)}
                  >
                    <h4>{animal.animal_subcat} - {animal.animal_cat}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <p>No data found.</p>
      )}
    </div>
  );
}
